<template>
  <div>
    <custom-result-not-found v-if="listOfItems.length == 0" />
    <div v-else>
      <sort-by
        @sort="setSort"
        :selected="OrderBy"
        hidden-shared
        show-shared-date
      />
      <div v-for="item in listOfItems" :key="item.id">
        <report-row :item="item" @load="$emit('load')" is-shared />
      </div>
      <pagination
        v-if="pagination.totalItemCount > pagination.perPage"
        :data="pagination"
        show-text
        @pagination-go-page="$emit('change-page', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { name as specialReportModuleName } from '@/modules/special-report/store'
import CustomResultNotFound from 'custom-result-not-found'
import Pagination from 'pagination'
import ReportRow from '../components/ReportRow'
import SortBy from '../components/SortBy'
import rbSorterBy from '@/utils/constants/rbSorterBy.js'
import _ from 'lodash'
export default {
  name: 'SharedWithMe',
  components: {
    ReportRow,
    SortBy,
    CustomResultNotFound,
    Pagination,
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    OrderBy: rbSorterBy.SharedDate,
    listOfItems: [],
  }),
  watch: {
    items: {
      handler: function() {
        this.setList()
      },
      deep: true,
    },
    OrderBy() {
      this.setList()
    },
  },
  mounted() {
    this.$emit('load')
  },
  methods: {
    ...mapActions(specialReportModuleName, ['setCurrentRow']),
    setSort(value) {
      this.OrderBy = value
      this.setCurrentRow(null)
    },
    setList() {
      this.listOfItems = this.items.map((e) => {
        return {
          ...e,
          shared: e?.shareData ? e?.shareData?.shared : false,
        }
      })
      switch (this.OrderBy) {
        case rbSorterBy.AZ:
          this.listOfItems = this.listOfItems.sort((a, b) =>
            a.name.localeCompare(b.name)
          )
          break
        case rbSorterBy.GenerateDate:
          this.listOfItems = this.listOfItems.sort((a, b) => {
            let lastBuildA = a.lastBuild
              ? new Date(a.lastBuild)
              : new Date('01/01/0001 00:00:00')
            let lastBuildB = b.lastBuild
              ? new Date(b.lastBuild)
              : new Date('01/01/0001 00:00:00')
            return lastBuildB - lastBuildA
          })
          break
        case rbSorterBy.ModifiedDate:
          this.listOfItems = this.listOfItems.sort(
            (a, b) => new Date(b.updatedDate) - new Date(a.updatedDate)
          )
          break
        case rbSorterBy.SharedDate:
          this.listOfItems = this.listOfItems.sort((a, b) => {
            let sharedDateA = a.shareData.sharedDate
              ? new Date(a.shareData.sharedDate)
              : new Date('01/01/0001 00:00:00')
            let sharedDateB = b.shareData.sharedDate
              ? new Date(b.shareData.sharedDate)
              : new Date('01/01/0001 00:00:00')
            return sharedDateB - sharedDateA
          })
          break
        case rbSorterBy.Shared:
          this.listOfItems = _.orderBy(this.listOfItems, ['shared'], ['desc'])
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
